var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-toolbar",
    { attrs: { color: "indigo-2", "text-color": "dark" } },
    [
      _c("q-toolbar-title", [
        _vm.imgsrc !== ""
          ? _c("img", { attrs: { src: _vm.imgsrc } })
          : _vm._e(),
        _vm._v("\n    " + _vm._s(_vm.wwwdescription) + "\n    ")
      ]),
      _vm.menusEdit.length > 0
        ? _c(
            "q-btn",
            { attrs: { flat: "", label: "Edycja" } },
            [
              _c(
                "q-popover",
                [
                  _c(
                    "q-list",
                    { attrs: { link: "" } },
                    _vm._l(_vm.menusEdit, function(menu) {
                      return _c(
                        "q-item",
                        {
                          directives: [
                            {
                              name: "close-overlay",
                              rawName: "v-close-overlay"
                            }
                          ],
                          key: menu.cnt,
                          nativeOn: {
                            click: function($event) {
                              return _vm.menuClick(menu)
                            }
                          }
                        },
                        [
                          _c(
                            "q-item-side",
                            { attrs: { inverted: "", color: "primary" } },
                            [
                              _c("img", {
                                attrs: { src: _vm.getICORURL + menu.image }
                              })
                            ]
                          ),
                          _c(
                            "q-item-main",
                            [
                              _c("q-item-tile", { attrs: { label: "" } }, [
                                _vm._v(_vm._s(menu.label))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.menusNew.length > 0
        ? _c(
            "q-btn",
            { attrs: { flat: "", label: "Nowe" } },
            [
              _c(
                "q-popover",
                [
                  _c(
                    "q-list",
                    { attrs: { link: "" } },
                    _vm._l(_vm.menusNew, function(menu) {
                      return _c(
                        "q-item",
                        {
                          directives: [
                            {
                              name: "close-overlay",
                              rawName: "v-close-overlay"
                            }
                          ],
                          key: menu.cnt,
                          nativeOn: {
                            click: function($event) {
                              return _vm.menuClick(menu)
                            }
                          }
                        },
                        [
                          _c(
                            "q-item-side",
                            { attrs: { inverted: "", color: "primary" } },
                            [
                              _c("img", {
                                attrs: { src: _vm.getICORURL + menu.image }
                              })
                            ]
                          ),
                          _c(
                            "q-item-main",
                            [
                              _c("q-item-tile", { attrs: { label: "" } }, [
                                _vm._v(_vm._s(menu.label))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.menusDelete.length > 0
        ? _c(
            "q-btn",
            { attrs: { flat: "", label: "Usuń" } },
            [
              _c(
                "q-popover",
                [
                  _c(
                    "q-list",
                    { attrs: { link: "" } },
                    _vm._l(_vm.menusDelete, function(menu) {
                      return _c(
                        "q-item",
                        {
                          directives: [
                            {
                              name: "close-overlay",
                              rawName: "v-close-overlay"
                            }
                          ],
                          key: menu.cnt,
                          nativeOn: {
                            click: function($event) {
                              return _vm.menuClick(menu)
                            }
                          }
                        },
                        [
                          _c(
                            "q-item-side",
                            { attrs: { inverted: "", color: "primary" } },
                            [
                              _c("img", {
                                attrs: { src: _vm.getICORURL + menu.image }
                              })
                            ]
                          ),
                          _c(
                            "q-item-main",
                            [
                              _c("q-item-tile", { attrs: { label: "" } }, [
                                _vm._v(_vm._s(menu.label))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.menusAction.length > 0
        ? _c(
            "q-btn",
            { attrs: { flat: "", label: "Akcje" } },
            [
              _c(
                "q-popover",
                [
                  _c(
                    "q-list",
                    { attrs: { link: "" } },
                    _vm._l(_vm.menusAction, function(menu) {
                      return _c(
                        "q-item",
                        {
                          directives: [
                            {
                              name: "close-overlay",
                              rawName: "v-close-overlay"
                            }
                          ],
                          key: menu.cnt,
                          nativeOn: {
                            click: function($event) {
                              return _vm.menuClick(menu)
                            }
                          }
                        },
                        [
                          _c(
                            "q-item-side",
                            { attrs: { inverted: "", color: "primary" } },
                            [
                              _c("img", {
                                attrs: { src: _vm.getICORURL + menu.image }
                              })
                            ]
                          ),
                          _c(
                            "q-item-main",
                            [
                              _c("q-item-tile", { attrs: { label: "" } }, [
                                _vm._v(_vm._s(menu.label))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("q-btn", {
        attrs: { flat: "", dense: "", icon: "refresh" },
        on: {
          click: function($event) {
            return _vm.$emit("refresh")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }